import * as React from 'react';

import {NothingFoundEmptyState} from 'shells/empty-states/nothing-found-empty-state';
import {ErrorState} from 'shells/error-state/error-state';
import {LoadingPage} from 'shells/loading-page/loading-page';
import type {SpecialState} from 'shells/table/types';

import type {MeetingStubFragment} from 'nutshell-graphql-types';

import {EmptyState} from './empty-state';
import {MeetingsTable} from './meetings-table';

import styles from './meetings-list-view.module.css';

type Props = {
    meetings: MeetingStubFragment[] | null | undefined;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
    isFiltering: boolean;
    specialStates?: SpecialState[];
};

export function MeetingsListView(props: Props) {
    const specialStates = [
        {
            shouldRender: () => Boolean(props.error),
            component: <ErrorState errorMessage={props.error} />,
        },
        {
            shouldRender: () => props.isLoading,
            component: (
                <div className={styles['loading-container']}>
                    <LoadingPage padding={4} />
                </div>
            ),
        },
        {
            shouldRender: () =>
                Boolean(
                    props.meetings &&
                        !props.meetings.length &&
                        !props.isLoading &&
                        props.isFiltering
                ),
            component: (
                <NothingFoundEmptyState
                    title='No meetings were found'
                    subtitle='Try loosening your search!'
                />
            ),
        },
        {
            shouldRender: () =>
                Boolean(props.meetings && !props.meetings.length && !props.isLoading),
            component: <EmptyState />,
        },
    ];

    return <MeetingsTable {...props} specialStates={specialStates} />;
}
